export default __webpack_public_path__ + "static/media/pigybank.1ede3811.png";